import React from "react";
import Modal from "react-bootstrap/Modal";
import TableHistoryOrderProductTable from "components/Tables/TableHistoryOrderProductTable";

export default function TableHistoryModal({ tableName, people, user, tableHistoryId, show, handleClose }) {
  return (
    <>
      <Modal size="xl" dialogClassName="my-modal" show={show} onHide={handleClose} aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton>
          <Modal.Title style={{ margin: 0 }}>
            {[[tableName, people != null ? `(${people})` : null].filter(Boolean).join(" "), user].filter(Boolean).join(" - ")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <TableHistoryOrderProductTable modalOpen={show} tableHistoryId={tableHistoryId} />
        </Modal.Body>
      </Modal>
    </>
  );
}
